import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AIMedia } from '../../@types';

type Payload = {
  mediaId: string;
  name: string;
};

const updateAiMedia = async (payload: Payload): Promise<AIMedia> => {
  const res = await axiosInstance.patch('/api/stock-gallery/update-ai-media', payload);
  return res.data;
};

export const useUpdateAiMedia = () => {
  return useMutation(updateAiMedia, { onSuccess: (data) => data });
};
